/* Copyright Information: Created by BuyGroup */
import * as Yup from "yup";

export const ValidationSchemaCategory = Yup.object({
  category_name: Yup.string().required("Please enter category name"),
});
export const ValidationSchemaSubCategory = Yup.object({
  category_name: Yup.string().required("Please enter sub category name"),
});
/* Copyright Information: Created by BuyGroup */